import { render, staticRenderFns } from "./ProjectListIndex.vue?vue&type=template&id=0c58754e"
import script from "./ProjectListIndex.vue?vue&type=script&lang=js"
export * from "./ProjectListIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports